"use client";

import { ShieldCheck, ArrowRight, Zap, RefreshCw } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecurityEfficiencyContinuity() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const pillars = [{
    number: "01",
    title: "Sicurezza Impiantistica",
    description: "Garantiamo la massima conformità normativa e sicurezza operativa attraverso interventi di bonifica tecnica specialistica su ogni componente.",
    icon: ShieldCheck,
    href: "/TechnicalDivisionPage",
    offset: "lg:mt-0"
  }, {
    number: "02",
    title: "Efficienza Energetica",
    description: "Ottimizziamo le prestazioni dei sistemi HVAC e di estrazione, riducendo i consumi e migliorando la qualità dell'aria negli ambienti di lavoro.",
    icon: Zap,
    href: "/HVACAirDuctsPage",
    offset: "lg:mt-16"
  }, {
    number: "03",
    title: "Continuità Operativa",
    description: "Pianifichiamo interventi di manutenzione specialistica per prevenire fermi impianto e garantire la massima longevità delle vostre infrastrutture.",
    icon: RefreshCw,
    href: "/TechnicalInspectionPage",
    offset: "lg:-mt-8"
  }];
  return <section data-section-id="5162" id="securityefficiencycontinuity" className="bg-background text-foreground py-24 md:py-32 lg:py-[140px] overflow-hidden">
      <div className="container mx-auto px-6 md:px-10">
        
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 mb-20 lg:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-7">
            <span className="inline-block text-xs tracking-[0.25em] uppercase font-mono mb-8" style={{
            color: "var(--primary)"
          }}>
              I Nostri Pilastri
            </span>
            <h2 className="font-default text-4xl md:text-5xl lg:text-[56px] leading-[1.05] tracking-tight" style={{
            color: "var(--secondary)"
          }}>
              Tecnologia e rigore
              <br />
              <span className="italic opacity-80">per la vostra sicurezza.</span>
            </h2>
          </div>
        </div>

        
        <div ref={gridRef} className="relative grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          
          <div aria-hidden="true" className="hidden lg:block absolute top-1/2 left-[16.66%] right-[16.66%] h-px pointer-events-none" style={{
          backgroundColor: "var(--border)"
        }} />

          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <div data-index={i} key={pillar.number} className={`${pillar.offset} transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: gridVisible ? `${i * 150}ms` : "0ms"
          }}>
                <Card className="group relative h-full bg-background border border-border hover:border-primary/60 rounded-lg p-10 md:p-12 transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-xl shadow-md flex flex-col">
                  <CardContent className="p-0 flex flex-col h-full">
                    <span className="font-mono text-xs tracking-[0.25em] uppercase mb-6" style={{
                  color: "var(--primary)"
                }}>
                      {pillar.number} / 03
                    </span>

                    <div className="mb-8">
                      <div className="inline-flex items-center justify-center w-16 h-16 rounded-lg border transition-all duration-500 ease-out group-hover:bg-primary/10" style={{
                    borderColor: "var(--border)"
                  }}>
                        <Icon className="w-8 h-8 transition-all duration-500 ease-out" strokeWidth={1.25} style={{
                      color: "var(--primary)"
                    }} />
                      </div>
                    </div>

                    <div className="mb-5 flex flex-col gap-3">
                      <h3 className="font-default text-2xl md:text-[28px] leading-tight" style={{
                    color: "var(--secondary)"
                  }}>
                        {pillar.title}
                      </h3>
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-lg text-[10px] font-mono uppercase tracking-wider bg-primary/10 text-primary w-fit border border-primary/20">
                        Technical Reliability
                      </span>
                    </div>

                    <p className="font-default text-base leading-relaxed text-muted-foreground mb-10 flex-grow">
                      {pillar.description}
                    </p>

                    <Link to={pillar.href} className="inline-flex items-center gap-2 text-sm font-mono uppercase tracking-[0.2em] text-foreground hover:text-primary transition-colors duration-300 mt-auto">
                      <span>Approfondisci</span>
                      <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
                    </Link>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}